module.exports = __webpack_public_path__ + "img/comercio-alimenticio-1.149d0263.png";